import type { Variant, SpinnerVariant } from "./types";

export const VARIANTS = ["primary", "secondary"] as const;
export const DEFAULT_VARIANT = "primary" satisfies Variant;

export const SPINNER_VARIANTS = {
  primary: "buttonPrimary",
  secondary: "buttonSecondary",
} as const satisfies SpinnerVariant;
